import React from 'react';
import { useBreakpoint } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
const ProblemAgitationSection = () => {
  const {
    isMobile
  } = useBreakpoint();
  return <section className="py-16 md:py-24 bg-white relative overflow-hidden">
      {/* Subtle background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/4 right-10 w-96 h-96 bg-[#FEE6D8]/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-10 w-72 h-72 bg-[#003a70]/5 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="space-y-8">
          
          {/* Opening hook - attention grabbing */}
          <div className={cn("text-center space-y-6 p-8 bg-gradient-to-br from-[#003a70]/5 to-[#FEE6D8]/20 rounded-2xl border border-[#FEE6D8]/50 shadow-lg", isMobile ? "p-6" : "p-10")}>
            <h2 className={cn("font-bold text-[#003a70] leading-tight", isMobile ? "text-2xl" : "text-3xl lg:text-4xl")}>
              The AI revolution is happening right now, and every business owner wants to be part of it...
            </h2>
            <p className={cn("text-gray-700 leading-relaxed", isMobile ? "text-lg" : "text-xl")}>
              But most consultants are missing the <strong className="text-[#003a70]">easiest entry point</strong> to sell AI services because they're overlooking the one thing every business owner already has.
            </p>
          </div>

          {/* Problem revelation */}
          <div className="space-y-6">
            <p className={cn("text-gray-800 leading-relaxed", isMobile ? "text-lg" : "text-xl")}>
              Here's what's crazy - while consultants are trying to figure out how to sell complex AI chatbots, automation systems, and marketing AI to skeptical business owners, there's one AI application that every single business owner immediately <em className="text-[#003a70] font-semibold">'gets'</em> and wants the moment they see it in action...
            </p>

            {/* The reveal - highlighted */}
            <div className="bg-[#FEE6D8] p-6 md:p-8 rounded-xl border-l-4 border-[#003a70] shadow-md">
              <p className={cn("text-[#003a70] font-bold leading-relaxed", isMobile ? "text-xl" : "text-2xl")}>
                It's the one thing every business owner already has but wishes actually worked for them - their business card.
              </p>
            </div>

            <p className={cn("text-gray-800 leading-relaxed", isMobile ? "text-lg" : "text-xl")}>
              When you show them how AI can transform that boring piece of paper into a <strong className="text-[#003a70]">lead-generating, question-answering, always-updated digital powerhouse</strong>, they don't need convincing. They need to know where to sign up.
            </p>
          </div>

          {/* Pain point agitation */}
          <div className="bg-gray-50 p-6 md:p-8 rounded-xl border border-gray-200 shadow-sm">
            <p className={cn("text-gray-800 leading-relaxed", isMobile ? "text-lg" : "text-xl")}>
              Yet most consultants are missing this goldmine because they're trapped in the traditional prospecting nightmare - the uncomfortable cold outreach, the pushy sales tactics, the feast-or-famine revenue cycles that come from avoiding the very thing their business depends on: <em className="text-red-600 font-semibold">getting new clients.</em>
            </p>
          </div>

          {/* Visual separator */}
          

        </div>
      </div>
    </section>;
};
export default ProblemAgitationSection;